import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {URL_IMG} from '../../../configs/urlConfigs';
import {MSG_REQUIRED,MSG_NOT_FOUND, MSG_SUBSECTOR_ADD_SUCCESS, MSG_SUBSECTOR_UPDATE_SUCCESS, MSG_SUBSECTOR_DELETE_SUCCESS,MSG_SECTOR_DELETE_424_ERROR} from '../../../configs/msgConfigs';
import {LBL_APP_NAME, LBL_SETTINGS, LBL_ADD_NEW, LBL_SECTOR, LBL_SECTORS, LBL_SUB_SECTOR, LBL_SUB_SECTORS, LBL_ACTIONS,LBL_CONFIRM_DELETE,LBL_BACK_TO_SETTINGS} from '../../../configs/labelConfigs'; 
import { ROUTE_REFRESH, ROUTE_SA_SETTINGS } from '../../../configs/staticConfigs';
import * as types from '../../../actions';

import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';

import {formValid} from '../../../utils/validation';
import {getSortClass} from '../../../utils/commonUtilities'; 

import {subSectorListAction, subSectorAddAction, subSectorEditAction, subSectorUpdateAction, subSectorDeleteAction} from '../../../actions/settings/superadmin/subSectorActions';
import {sectorAllListAction} from '../../../actions/settings/superadmin/sectorActions';
import {clearAction} from '../../../actions/commonActions';

class SubSectorsComponent extends Component { 
    constructor(props){
        super()

        this.state = {          
            activeRowId:0,            
            formErrors:{
                sectorId:'',
                subSectorName: "",
            },          
            subSectorData:{ 
                sectorId:null,
                subSectorId:0,
                subSectorName: null,               
            },
            sortField:'sector__name',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);
        this.modalDelete = React.createRef();
        this.modal = React.createRef();
    }

    openModal() {
        let formErrors = this.state.formErrors;
        formErrors.subSectorName = '';
        formErrors.sectorId = '';
        this.setState({formErrors});
        this.modal.current.handleOpenModal();
    }   

    onModalFormReset = () =>{          
        this.setState({subSectorData:{
            subSectorId:'',
            sectorId:null,
            subSectorName:null
        }}); 
    }

    onHandleChange = (event) =>{
        const {name, value} = event.target;
        let trimmedValue = '';

        let formErrors     = this.state.formErrors;
        if(event.target.type==="text"){
            trimmedValue = value.trim(); 
        }
        switch(name){    
            case 'sectorId':
                formErrors.sectorId = 
                value.length <=0 || Number(value)===0
                ? MSG_REQUIRED
                : ""
                break;        
            case 'subSectorName':
                formErrors.subSectorName = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;                     
            default :
            break;
        }

        let subSectorData   = this.state.subSectorData;
        subSectorData[name] = value;

        this.setState({formErrors,subSectorData});
    }    

    onShowActionButtons = (event, rowId) =>{

        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }        
        
    }   
    
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSaveFormData = (id) =>{
        if(formValid(this.state)){
            let formErrors = this.state.formErrors;  

            if(id){         
                let subSectorData= {
                    id:id,
                    name: this.state.subSectorData.subSectorName, 
                    sector:this.state.subSectorData.sectorId                     
                } 
                this.props.subSectorUpdateAction(subSectorData);  
            }else{           
                let subSectorData= {
                    name: this.state.subSectorData.subSectorName,  
                    sector:this.state.subSectorData.sectorId                    
                } 
                this.props.subSectorAddAction(subSectorData);
            }  
            this.setState({formErrors});    
           
        }else{
            let formErrors = this.state.formErrors;
            if(this.state.subSectorData.sectorId==null){
                formErrors.sectorId = MSG_REQUIRED;
            }  
            if(this.state.subSectorData.subSectorName==null){
                formErrors.subSectorName = MSG_REQUIRED;
            }           
            this.setState({formErrors});
        }
    }

    editBtnClick = (rowId) =>{  
        let formErrors = this.state.formErrors;
        formErrors.subSectorName = '';
        formErrors.sectorId = '';
        this.setState(formErrors);
        this.modal.current.handleOpenModal();
        this.props.subSectorEditAction(rowId);
    }

    deleteBtnClick = (rowId,name) =>{
        this.setState({
            subSectorData: {
                subSectorId: rowId,   
                subSectorName:name            
            }
        }); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        let subSectorId = this.state.subSectorData.subSectorId;
        this.props.subSectorDeleteAction(subSectorId);
        this.modalDelete.current.handleModelClose();              
    }

    onSort = (event,sortKey) =>{        
        let sOrder = '';
        if(this.state.sortField===sortKey){         
            sOrder = (this.state.sortOrder==='-') ? '' : '-';
            this.props.subSectorListAction({column:sOrder+this.state.sortField});
            this.setState({ sortOrder:sOrder });            
        }else{
            this.setState({ sortField:sortKey });
            this.props.subSectorListAction({column:this.state.sortOrder+sortKey});
        }        
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }   

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 4000);
    }

    setStateUpdate(sectors,status,activity,subSector,errorData){
        let formErrors = this.state.formErrors;

        if(activity===types.SUBSECTOR_ADD_SUPERADMIN_SUCCESS){
            this.modal.current.handleModelClose();
            this.props.subSectorListAction({column:this.state.sortOrder+this.state.sortField});
            this.setToasterState(true,MSG_SUBSECTOR_ADD_SUCCESS,true);
        } else if(activity===types.SUBSECTOR_ADD_SUPERADMIN_ERROR){  
            if(status===400){
                if(errorData.hasOwnProperty('name')){  
                    formErrors.subSectorName = errorData.name[0];
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
            }
        }else if(activity===types.SUBSECTOR_UPDATE_SUPERADMIN_SUCCESS){
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_SUBSECTOR_UPDATE_SUCCESS,true);
        }else if(activity===types.SUBSECTOR_UPDATE_SUPERADMIN_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('name')){ 
                    formErrors.subSectorName = errorData.name[0];
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors); 
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
            }
        }else if(activity===types.SUBSECTOR_EDIT_SUPERADMIN_SUCCESS){    
            this.setState({subSectorData:{
                sectorId:subSector.sectorId,
                subSectorId:subSector.id,
                subSectorName:subSector.name
            }}, () => {
                if(document.getElementById('sectorId')) {
                    document.getElementById('sectorId').focus(); 
                }
            });
        }else if(activity===types.SUBSECTOR_DELETE_SUPERADMIN_SUCCESS){
        
            this.props.subSectorListAction({column:this.state.sortOrder+this.state.sortField});
            
            this.setToasterState(true,MSG_SUBSECTOR_DELETE_SUCCESS,true);  
        }else if(activity===types.SUBSECTOR_DELETE_SUPERADMIN_ERROR){
            let errMsg = ''; 
            if(status===424) errMsg = MSG_SECTOR_DELETE_424_ERROR; 
            else {
                errMsg = errorData.message ? JSON.stringify(errorData.message) : JSON.stringify(errorData);
            }
            this.setToasterState(true,errMsg,false);
        }
    }
    

    componentDidUpdate(prevProps) {     
        const { sectors,status,activity,subSector,errorData} = this.props;
        if (activity !== prevProps.activity) {
            this.setStateUpdate(sectors,status,activity,subSector,errorData);
            this.props.clearAction();
        }
    }

    componentDidMount() {        
        this.props.subSectorListAction({page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});  
        this.props.sectorAllListAction();  
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" -  "+LBL_SUB_SECTORS;
    } 


    render(){

        const {
            toastMessage,toastFlag,toastSuccess,subSectorData,sortField,sortOrder,          
        } = this.state

        const { subSectors,sectors,status} = this.props; 
                
        if(status===401 || status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        return(        

            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="to-right">                                   
                            <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_ADD_NEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th onClick={(e) => this.onSort(e,'sector__name')} className="sector spanPointer">{LBL_SECTORS} <i className={sortField=='sector__name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                        <th onClick={(e) => this.onSort(e,'name')} className="sub-sector spanPointer">{LBL_SUB_SECTORS} <i className={sortField=='name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                        <th>{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(this.props.count===0) && 

                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                {subSectors.map((item,index) => {
                                    let sector = sectors.find(el => el.id ===item.sector);
                                    let sectorName = (sector) ? sector.name : '';
                                    return (
                                        <tr key={item.id}>
                                            <td>{index+1}</td>
                                            <td>{sectorName}</td>
                                            <td>{item.name}</td>
                                            <td>
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                    >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                    <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>Edit</Link>
                                                    <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.name)}>Delete</Link>
                                                </div>
                                            </div>
                                            </td>
                                        </tr>             
                                        
                                     )
                                  })      

                                }                   
                                </tbody>
                            </table>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {"Are you sure you want to delete sub sector '"+subSectorData.subSectorName+"'?"}
                </ModalWindow>

                <ModalWindow ref={this.modal} header={Number(this.state.subSectorData.sectorId) > 0 ? "Edit "+LBL_SUB_SECTOR : "Add "+LBL_SUB_SECTOR}  saveFormData={ (e)=>this.onSaveFormData(subSectorData.subSectorId)} resetModalForm={this.onModalFormReset} autoFocusField='sectorId'>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_SECTOR}</label>
                                <div className="form-group select-input">
                                    <select className={this.state.formErrors.sectorId.length >0 ? "input-error" : ''} name="sectorId" id="sectorId" onChange={this.onHandleChange} value={subSectorData.sectorId||''}>
                                        <option value="0">Select</option>
                                    {sectors.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}                                     
                                    </select>
                                    {this.state.formErrors.sectorId.length >0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrors.sectorId}</div>
                                    )} 
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_SUB_SECTOR}</label>
                                <div className="text-input"><input className={this.state.formErrors.subSectorName.length >0 ? "input-error" : ''} type="text" name="subSectorName" onChange={this.onHandleChange} placeholder="" value={subSectorData.subSectorName||''} maxLength = {120} />
                                {this.state.formErrors.subSectorName.length >0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrors.subSectorName}</div>
                                )} 
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalWindow>
            </div>
        )
        
    }
    
}
const mapStateToProps = (state) => {
    return {
        subSectors : state.subSectors.items,
        subSector:state.subSectors.item,
        status:state.subSectors.status,
        activity:state.subSectors.activity,
        sectors:state.subSectors.sectors,
        count:state.subSectors.count,
        errorData:state.subSectors.errorData
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        subSectorListAction:subSectorListAction,  
        sectorAllListAction:sectorAllListAction,
        subSectorAddAction:data=>subSectorAddAction(data),
        subSectorEditAction:id=>subSectorEditAction(id),
        subSectorUpdateAction:data=>subSectorUpdateAction(data),
        subSectorDeleteAction:id=>subSectorDeleteAction(id),
        clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(SubSectorsComponent);